<template>

    <v-container class="fill-height data-container" fluid>
        <v-row>
            <v-col cols="12" md="6">
                <v-autocomplete v-model="switchSelected" :items="switchList" multiple color="#c42111" label="Switch" @change="onChange" />
            </v-col>
            <v-col cols="12" md="6">
                <v-autocomplete v-model="localeSelected" :items="localeList" multiple color="#c42111" label="Locale" @change="onChange" />
            </v-col>
            <v-col cols="12" md="6">
                <v-autocomplete v-model="technicianSelected" :items="technicianList" multiple color="#c42111" label="Technician" @change="onChange" />
            </v-col>
            <v-col cols="12" md="6">
                <v-autocomplete v-model="groupsSelected" :items="groupsList" multiple color="#c42111" label="Groups" @change="onChange" />
            </v-col>
        </v-row>
        <v-checkbox v-model="$props.userThreshold.thres_intersect" color="#c42111" label="Intersect" :disabled="!groupsSelected.length" />
    </v-container>

</template>

<script>
export default {
    name: 'Filters',
    props: ['filtering', 'userThreshold', 'reset'],
    components: {

    },
    data: () => ({
        switchList: [],
        localeList: [],
        technicianList: [],
        groupsList: [],
        switchSelected: [],
        localeSelected: [],
        technicianSelected: [],
        groupsSelected: [],
    }),

    computed: {

    },

    methods: {
        parseFilters: function() {
            // Build resource lists
            for(const filter of this.filtering) {
                if(filter.site_office && !this.switchList.includes(filter.site_office)) {
                    this.switchList.push(filter.site_office);
                }
                if(filter.site_locale && !this.localeList.includes(filter.site_locale)) {
                    this.localeList.push(filter.site_locale);
                }
                if(filter.user_username && !this.technicianList.includes(filter.user_username)) {
                    this.technicianList.push(filter.user_username);
                }
                for(let group of filter.site_group_name) {
                    if(group && !this.groupsList.includes(group)) {
                        this.groupsList.push(group);
                    }
                }
            }

            this.switchList.sort();
            this.localeList.sort();
            this.technicianList.sort();
            this.groupsList.sort();

            // Apply values
            let filterArr = this.$props.userThreshold.thres_filter.split('|');
            this.switchSelected = filterArr[0] ? filterArr[0].split(',') : [];
            this.localeSelected = filterArr[1] ? filterArr[1].split(',') : [];
            this.technicianSelected = filterArr[2] ? filterArr[2].split(',') : [];
            this.groupsSelected = filterArr[3] ? filterArr[3].split(',') : [];
        },

        onChange: function() {
            const switchStr = this.switchSelected.join(',');
            const localeStr = this.localeSelected.join(',');
            const technicianStr = this.technicianSelected.join(',');
            const groupsStr = this.groupsSelected.join(',');
            let filterStr = `${switchStr}|${localeStr}|${technicianStr}|${groupsStr}`;
            this.$props.userThreshold.thres_filter = filterStr;
        }

    },

    watch: {
        reset: {
            handler(newVal, oldVal) {
                this.parseFilters();
            },
            deep: true
        },
    },

    mounted() {
        this.parseFilters();
    }

  
};
</script>
